export const sections = {
  coverage: "coverage",
  screening: "screening",
  protection: "protection",
  kiosk: "kiosk",
  topSymptoms: "topSymptoms",
};

export const logDetailsPermissions = {
  read: true,
  update: false,
  override: false,
  notes: {
    read: true,
    create: false,
  },
};
